<template>
  <fragment>
    <div class="header" v-if="header">{{ header }}</div>
    <!-- RegexField for match -->
    <div class="item" ref="menuTarget">
      <regex-field
        v-model.trim="match"
        :labelText="$t('MATCH_WINDOW_REGEX')"
        @input="emitTokenUpdate"
        size="mini"
        :actions="resolved ? [{ name: 'menu', icon: 'horizontal ellipsis' }] : []"
        @action="onAction"
      />
      <div
        ref="matchTitleOptionsMenu"
        class="menu transition"
        :class="{ visible: showMatchTitleOptions, hidden: !showMatchTitleOptions }"
        :style="[showMatchTitleOptions ? 'display: block !important;' : 'display: none;']"
      >
        <div
          class="item"
          v-for="p in resolvedProperties"
          :key="p.value"
          @click="updateTitle(p.value)"
        >
          {{ p.value }}
        </div>
      </div>
    </div>
    <div class="item">
      <div class="ui checkbox">
        <input type="checkbox" name="global" v-model="global" @change="emitTokenUpdate" />
        <label>{{ $t('TOKEN_WINDOW_GLOBAL') }}</label>
      </div>
    </div>
  </fragment>
</template>

<style lang="scss" scoped></style>

<script>
// @flow
import Vue from 'vue'
import { RegexField } from 'ui'
import { Fragment } from 'vue-frag'

export default {
  name: 'WindowTokenMenuFragment',
  props: ['token', 'resolved', 'header'],
  components: {
    Fragment,
    RegexField
  },

  data() {
    return {
      global: this.token?.global ?? false,
      match: this.token?.title ?? '',
      showMatchTitleOptions: false
    }
  },

  computed: {
    resolvedProperties() {
      return this.resolved ? [{ name: this.resolved.title, value: this.resolved.title }] : []
    }
  },

  methods: {
    emitTokenUpdate() {
      this.$emit('token-update', { ...this.token, title: this.match, global: this.global })
    },
    updateTitle(t) {
      this.$emit('token-update', { ...this.token, title: t, global: this.global })
      this.showMatchTitleOptions = false
    },
    onAction(a) {
      if (this.resolved && a.name === 'menu') {
        this.showMatchTitleOptions = !this.showMatchTitleOptions

        // No need to place the menu below the input if we're closing it
        if (!this.showMatchTitleOptions) return

        // place menu below the evt target
        const menu = this.$refs.matchTitleOptionsMenu
        const target = this.$refs.menuTarget
        console.debug('target is', target)
        menu.style.position = 'absolute'
        menu.style.left = target.offsetLeft + 20 + 'px'
        menu.style.top = target.offsetTop - 10 + 'px'
      }
    }
  }
}
</script>
